import { HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';

import { TokenService } from '../../services/token.service';
import { environment } from '../../../environments/environment';
import { HeaderComponent } from '../../layout/header/header.component';
import { NavbarComponent } from '../../layout/navbar/navbar.component';
import { AppConfigService } from '../../services/core/appConfig.service';
import { SharedService } from '../../services/shared.service';
import { take } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';


const CHARACTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789_-.~";

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [HeaderComponent, NavbarComponent],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css'
})
export class LoginComponent implements OnInit {
  typeUser!: string;

  private params: any = {
    client_id: '',
    response_type: environment.response_type,
    state: '',
    scope: '',
    nonce: '',
    redirect_uri: ''
  }

  loading: boolean = false;

  constructor(private readonly tokenService: TokenService,
    private readonly configService: AppConfigService,
    private readonly sharedService: SharedService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly router: Router) {
    this.params.redirect_uri = this.configService.apiUrlFront
  }

  ngOnInit(): void {

    this.tryLogin();

    // Nos subscribimos para saber si la página ha sido iniciada para mostrar el contenido
    this.sharedService.initLoadingInitPage
      .pipe(take(1))
      .subscribe(iniPage => {
        if (iniPage) {
          this.loading = iniPage;
        }
      })
  }

  /**
 * Intenta iniciar sesión o continuar el flujo de autenticación según el estado actual.
 *
 * Escenarios gestionados:
 * 1. Usuario ya autenticado (access_token válido y sesión válida): redirige a /welcome.
 * 2. Hay intento de login pendiente (loginStarted), pero sin code -> limpia sesión interrumpida.
 * 3. No se ha iniciado login -> lanza el proceso de autenticación.
 */
  async tryLogin() {
    let loginStarted = !!sessionStorage.getItem('loginStarted');

    // Caso 1: Usuario ya autenticado correctamente
    if (this.tokenService.isAuthenticate()) {
      this.router.navigate(['/front', 'welcome']).then(() => {
        if (loginStarted) {
          this.deleteSessionLoginStarted();
        }
      });
      return;
    }

    // Caso 2: No hay login activo -> iniciar proceso de autenticación
    if (!loginStarted) {
      this.onLogin();
    }
  }

  private deleteSessionLoginStarted(): void {
    sessionStorage.removeItem('loginStarted');
  }

  /**
   * Función login que habilita el login de la UOC
   */
  async onLogin() {
    sessionStorage.setItem('loginStarted', '1');

    //event.preventDefault();
    this.tokenService.getParamConfigLong().subscribe({
      next: async response => {
        try {
          console.log(response)
          localStorage.setItem('urlConfig', response.oauthToken)
          this.params.state = await this.generateCodeChallenge(this.generateCodeVerify());
          this.params.nonce = await this.generateCodeChallenge(this.generateCodeVerify());
          localStorage.setItem("client_id", response.oauthClientId);
          localStorage.setItem("url_token", response.oauthToken);
          this.params.client_id = response.oauthClientId;
          this.params.scope = response.scope.split(',').find((scope: any) => scope === 'openid');
          const httpParams = new HttpParams({ fromObject: this.params });
          const urlCode = response.oauthIssuer + httpParams.toString();
          // Redirigimos al usuario a la pagina de login de la UOC
          location.href = urlCode;
        } catch (e) {
          sessionStorage.removeItem('loginStarted');
        }
      }, error: error => {
        console.log(error);
        sessionStorage.removeItem('loginStarted');
      }
    });
  }

  /**
   * Función encargada de generar el Verifie para poder enviarlo en la autenticación
   * @returns 
   */
  generateCodeVerify(): string {
    let resultCode = '';
    // Para generar el código debemos de crearnos una constante que contenga 44 carácteres.
    const tamanioConst = CHARACTERS.length;
    for (let i = 0; i < 44; i++) {
      resultCode += CHARACTERS.charAt(Math.floor(Math.random() * tamanioConst));
    }
    return resultCode;
  }

  /**
   * Función encargada de cifrar el Code Verifier
   * @param codeVerifier 
   * @returns 
   */
  async generateCodeChallenge(codeVerifier: string): Promise<string> {
    const encoder = new TextEncoder();
    const data = encoder.encode(codeVerifier);
    // Usar Web Crypto API para generar el hash SHA-256
    const hash = await crypto.subtle.digest('SHA-256', data);
    return this.arrayBufferToBase64Url(hash);
  }

  /**
   * Función auxiliar para convertir ArrayBuffer en Base64-url
   * @param buffer 
   * @returns 
   */
  arrayBufferToBase64Url(buffer: ArrayBuffer): string {
    const bytes = new Uint8Array(buffer);
    let binary = '';
    for (const byte of bytes) {
      binary += String.fromCharCode(byte);
    }
    const base64String = btoa(binary);
    return base64String
      .replace(/\+/g, '-') // Sustituir "+" por "-"
      .replace(/\//g, '_') // Sustituir "/" por "_"
      .replace(/=+$/, ''); // Eliminar "=" al final
  }



  getName(): string {
    return this.tokenService.obtainNameUser();
  }



}
